var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7959 2.54597L7.79593 14.546C7.69141 14.6509 7.56722 14.7341 7.43047 14.7909C7.29373 14.8476 7.14712 14.8769 6.99905 14.8769C6.85099 14.8769 6.70438 14.8476 6.56763 14.7909C6.43089 14.7341 6.30669 14.6509 6.20218 14.546L0.952177 9.29598C0.84753 9.19133 0.764519 9.06709 0.707885 8.93037C0.65125 8.79364 0.622101 8.64709 0.622101 8.4991C0.622101 8.35111 0.65125 8.20456 0.707885 8.06783C0.764519 7.93111 0.84753 7.80687 0.952177 7.70223C1.05682 7.59758 1.18106 7.51457 1.31779 7.45793C1.45451 7.4013 1.60106 7.37215 1.74905 7.37215C1.89705 7.37215 2.04359 7.4013 2.18032 7.45793C2.31705 7.51457 2.44128 7.59758 2.54593 7.70223L6.99999 12.1563L18.2041 0.9541C18.4154 0.742755 18.702 0.624023 19.0009 0.624023C19.2998 0.624023 19.5865 0.742755 19.7978 0.9541C20.0091 1.16544 20.1279 1.45209 20.1279 1.75098C20.1279 2.04986 20.0091 2.33651 19.7978 2.54785L19.7959 2.54597Z",
    fill: "#FF2828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRed);
export default __webpack_public_path__ + "static/media/check_red.32c06e74ff3355f2b1d8cb937bd07e46.svg";
export { ForwardRef as ReactComponent };